import * as React from 'react';
import { Box } from '@lcifr/components/box';
import { Wrap as LuciferWrap } from '@lcifr/components/wrap';
import { Image } from 'components/Image';
import { sx } from '@lcifr/sx';
import { Anchor } from '@lcifr/components/anchor';
import { CollectionType } from '@lcifr/components/collection';
import Link from 'next/link';
import { Heading } from '@lcifr/components/heading';
import { useCollection, useRawI18n } from '@lcifr/pages';
import { Button } from '@lcifr/components/button';
import { Icon } from '@lcifr/components/icon';
import { Stack } from '@lcifr/components/stack';
import { LinkStudio } from '@lcifr/components/link';
import { Section } from '@lcifr/components/section';

export const Stage = sx(Box)({
  background:
    'linear-gradient(180deg, rgba(15, 17, 37, 0.1) 0%, rgba(15, 17, 37, 0.03) 100%)',
});

type HeroJobProps = {
  width?: any;
  minHeight?: any;
  bg?: any;
  bgImage?: any;
  spaceT?: any;
  spaceB?: any;
  stackSpace?: any;
  id?: any;
  vRhythm?: any;
  pageId: any;
};

export function HeroJob({
  width,
  minHeight,
  bg,
  bgImage,
  spaceT,
  spaceB,
  stackSpace,
  id,
  vRhythm,
  pageId,
}: HeroJobProps) {
  const career = useRawI18n()?.career;
  const jobList = career?.jobList;
  const backText = career?.linkCareerText;
  const backLink = career?.linkCareer;

  const jobListCollection = useCollection(jobList);
  const currentJob = jobListCollection.findIndex(
    (product) => product._id === pageId,
  );

  const headline = (jobListCollection as any)?.[currentJob]?.headline;
  const summary = (jobListCollection as any)?.[currentJob]?.summary;

  return (
    <Box sx={{ '> div > div': { pl: '0 !important', pr: '0 !important' } }}>
      <Section
        width="full"
        minHeight={minHeight}
        bg={bg}
        bgImage={bgImage}
        spaceT={[null]}
        spaceB={spaceB}
        stackSpace={0}
        id={id}
        vRhythm={vRhythm}
      >
        <Stage>
          <LuciferWrap width="normal">
            <Box
              sx={{
                display: 'grid',
                height: '60vh',
                maxHeight: [280, 280, 480],
                alignItems: 'flex-end',
                pb: [40, 40, 80],
              }}
            >
              <Stack space={3}>
                <LinkStudio link={backLink}>
                  <Button
                    variant="strippedPrimary"
                    sx={{
                      fontSize: '16px !important',
                      textTransform: 'uppercase',
                      letterSpacing: '3px',
                    }}
                  >
                    <Icon name="chev-left" sx={{ mr: 2, color: 'primary' }} />
                    {backText}
                  </Button>
                </LinkStudio>
                {headline && <Heading variant="h1">{headline}</Heading>}
                {summary && (
                  <Heading variant="h4" sx={{ fontWeight: 400 }}>
                    {summary}
                  </Heading>
                )}
              </Stack>
            </Box>
          </LuciferWrap>
        </Stage>
      </Section>
    </Box>
  );
}
